// Requires jQuery and slick library to be loaded first!
const moment = require('moment');

(function($) {


    function formatDate(date) {
        var d = date,
            month = '' + (d.getMonth() + 1),
            day = '' + d.getDate(),
            year = d.getFullYear();

        return [day, month, year].join('-');
    }

    $.fn.birthdaypick = function() {
        for (var i = 0; i < this.length; i++) {
            $(this[i]).addClass('birthdatepicker').attr('readonly', 'readonly').datepicker({
                format: 'dd-mm-yyyy',
                date: new Date('01/01/1990'),
            });
            // const picker = datepicker(this[0], {
            //     // Event callbacks.
            //     // onSelect: function (instance) {
            //     //     // Show which date was selected.
            //     //     console.log(instance.dateSelected);
            //     // },
            //     // onShow: function (instance) {
            //     //     console.log('Calendar showing.');
            //     // },
            //     // onHide: function (instance) {
            //     //     console.log('Calendar hidden.');
            //     // },
            //     // onMonthChange: function (instance) {
            //     //     // Show the month of the selected date.
            //     //     console.log(instance.currentMonthName);
            //     // },

            //     // Customizations.
            //     formatter: function (el, date, instance) {
            //         el.value = moment(date).format('DD-MM-YYYY');
            //     },

            //     position: 'bl', // Top right.
            //     startDay: 1, // Calendar week starts on a Monday.
            //     customDays: ['S', 'M', 'T', 'W', 'Th', 'F', 'S'],
            //     customMonths: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
            //     overlayButton: 'Go!',
            //     overlayPlaceholder: 'Enter a 4-digit year',

            //     // Settings.
            //     // alwaysShow: true, // Never hide the calendar.
            //     // dateSelected: new Date(), // Today is selected.
            //     maxDate: new Date(), // Jan 1st, 2099.
            //     // minDate: new Date(1, 5, 1), // June 1st, 2016.
            //     startDate: new Date(), // This month.

            //     // Disabling things.
            //     noWeekends: false, // Saturday's and Sunday's will be unselectable.
            //     // disabler: date => (date.getDay() === 2 && date.getMonth() === 9), // Disabled every Tuesday in October
            //     // disabledDates: [new Date(2050, 0, 1), new Date(2050, 0, 3)], // Specific disabled dates.
            //     disableMobile: false, // Conditionally disabled on mobile devices.
            //     disableYearOverlay: false, // Clicking the year or month will *not* bring up the year overlay.

            //     // Id - be sure to provide a 2nd picker with the same id to create a daterange pair.
            //     id: 1
            // });
        }
    }
})(jQuery);